import { observer } from "mobx-react";
import React from "react";
import Button from "./Button";

@observer
class ShareButton extends React.Component {
  onClick = () => {
    this.props.onClick()
  };
  render() {
    const { className } = this.props;
    return (
      <Button
        clickAction={this.onClick}
        classes={`btn-normal ${className}`}
        style={undefined}
        text="Share"
      />
    );
  }
}

export default ShareButton;
